module.exports = __webpack_public_path__ + "media/images/health-79855ec02318539414a9c1cf8a6f6960.jpg";